import React from "react";
import { Helmet } from "react-helmet-async";


// Componente reutilizable para manejar SEO dinámico.
// Permite cambiar:
// - título
// - descripción SEO
// - Open Graph para redes sociales
function HelmetSEO({
    titulo = "Zervicy",
    descripcion = "Reserva servicios de forma fácil y segura.",
    imagen = "/logo192.png"
}) {

    return (
        <Helmet>

            {/*
                TITLE
                Título principal de la página.
                Lo usan:
                - Google
                - pestaña del navegador
                - Analytics
            */}
            <title>{titulo}</title>


            {/*
                META DESCRIPTION
                Descripción SEO para buscadores como Google.
                Normalmente aparece en el snippet gris.
            */}
            <meta
                name="description"
                content={descripcion}
            />


            {/*
                OPEN GRAPH TITLE
                Título usado al compartir links en:
                - WhatsApp
                - Facebook
                - Discord
                - Telegram
                - LinkedIn
            */}
            <meta
                property="og:title"
                content={titulo}
            />


            {/*
                OPEN GRAPH DESCRIPTION
                Descripción usada en previews sociales.
            */}
            <meta
                property="og:description"
                content={descripcion}
            />


            {/*
                OPEN GRAPH IMAGE
                Imagen preview al compartir links.
            */}
            <meta
                property="og:image"
                content={imagen}
            />


            {/*
                TWITTER CARD
                Mejora previews en Twitter/X.
            */}
            <meta
                name="twitter:card"
                content="summary_large_image"
            />

            <meta
                name="twitter:title"
                content={titulo}
            />

            <meta
                name="twitter:description"
                content={descripcion}
            />

            <meta
                name="twitter:image"
                content={imagen}
            />

        </Helmet>
    );
}


export default HelmetSEO;